"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDaysWithPayDays = void 0;
const luxon_1 = require("luxon");
function useDaysWithPayDays({ payCalendar, futureDateOnly }) {
    const today = luxon_1.DateTime.now().toISODate();
    let filteredPayPeriodList = (payCalendar === null || payCalendar === void 0 ? void 0 : payCalendar.payPeriodList) || [];
    if (futureDateOnly) {
        filteredPayPeriodList = filteredPayPeriodList.filter((payPeriod) => payPeriod.payDate >= today);
    }
    return filteredPayPeriodList
        .map((payPeriod) => payPeriod.payDate ? luxon_1.DateTime.fromISO(payPeriod.payDate) : null)
        .filter((dateTime) => !!dateTime);
}
exports.useDaysWithPayDays = useDaysWithPayDays;
